import { RadioButton } from "primereact/radiobutton";
import { classNames } from "primereact/utils";

import styles from "./selectable-card.module.scss";
import type { SelectableCardViewProps } from "./types-selectable-card";

export function SelectableCardView<T = string>({
  className,
  style,
  selected,
  disabled,
  rest,
  control,
  radioProps,
  inputProps,
  onInputChange,
  children,
}: SelectableCardViewProps<T>) {
  return (
    <label
      className={classNames(styles.root, className)}
      style={style}
      data-checked={selected || undefined}
      data-disabled={disabled || undefined}
      {...rest}
    >
      {control === "radio" ? (
        <RadioButton {...radioProps} className={styles.radio} />
      ) : (
        <input type="radio" className={styles.input} {...inputProps} onChange={onInputChange} />
      )}
      {children}
    </label>
  );
}
